import React from 'react';
import PageShell from '../components/page/PageShell';
import PageHeader from '../components/page/PageHeader';
import PageState from '../components/page/PageState';
import { useApp } from '../context/AppContext';
import ApplicableRegulationsPanel from '../components/regulatory/ApplicableRegulationsPanel';
import { canSeeApplicableRegulations } from '../utils/regulatoryModel';

/** "Which authorities apply?" for the open project; Lead Advisor / Advisor only (the API also requires project membership). */
const ProjectRegulationsPage = () => {
    const { user, activeProject } = useApp();
    if (!canSeeApplicableRegulations(user?.role)) {
        return <PageState status="empty" message="Applicable regulations are not available for your role." />;
    }
    if (!activeProject) return <PageState status="empty" message="Open a project to see which regulators apply to it." />;
    return (
        <PageShell>
            <PageHeader title="Which authorities apply?" subtitle={activeProject.companyName || activeProject.name} />
            <ApplicableRegulationsPanel projectId={activeProject.id} />
        </PageShell>
    );
};

export default ProjectRegulationsPage;
